import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';

@Component({
  selector: 'app-permissao-editar',
  templateUrl: './permissao-editar.component.html',
  styleUrls: ['./permissao-editar.component.scss']
})
export class PermissaoEditarComponent implements OnInit {

  constructor(private activatedRouter: ActivatedRoute, 
    private permissaoService: PermissaoService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  id?: number;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  loadingPermissao: boolean = false;
  tipos: String[] = ['EMPRESA', 'FRANQUIA'];
  categoriasPermissoes: CategoriaPermissao[] = [];
  permissao?: Permissao;

  ngOnInit(): void {
    this.loadingPermissao = true;
    this.carregarIdPermissao();
    this.listarCategorias();
  }

  listarCategorias(){
    this.categoriaPermissaoService.listarTodos().subscribe({
      next: (data: CategoriaPermissao[]) => {
        this.categoriasPermissoes = data;
        this.carregarPermissao();
      },
      error: (err: any) => {
        this.loadingPermissao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  carregarPermissao(){
    this.permissaoService.buscarPorId(this.id).subscribe({
      next: (data: Permissao) => {
        this.loadingPermissao = false;
        this.permissao = data;
      },
      error: (err: any) => {
        this.loadingPermissao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.permissaoService.atualizar(this.permissao).subscribe({
      next: (data: Permissao) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    })
    
  }
  

  carregarIdPermissao(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  

}
